import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { ItemForTrashSchema } from '@erikdakoda/ai-tool/ItemForTrash';

export const trashPromptInputSchema = z.object({
  action: z.enum(['trash', 'restore']),
  promptId: z.string(),
});

export const trashPromptOutputSchema = z.object({
  queryArgs: z.object({
    where: z.object({ id: z.string() }),
    data: ItemForTrashSchema.omit({ id: true }),
  }),
  queryResult: ItemForTrashSchema.nullable()
    .optional()
    .describe('The trashed or restored item; null if not found.'),
  error: z.unknown().nullable(),
});

export type TrashPromptInput = z.infer<typeof trashPromptInputSchema>;
export type TrashPromptOutput = z.infer<typeof trashPromptOutputSchema>;

export const trashPrompt: AiTool<undefined, TrashPromptInput, TrashPromptOutput> = {
  id: 'trashPrompt',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: 'Soft-delete a prompt (trash) or restore it from trash.',
    inputSchema: zodSchema(trashPromptInputSchema),
    outputSchema: zodSchema(trashPromptOutputSchema),
  }),
};
